import { z } from 'zod';

const CurationTypeSchema = z.enum(['GOODS', 'SNAP2']);

export const GetCurationsServiceRequestSchema = z
  .object({
    snsTitle: z.string(),
    page: z.number().min(1),
    // NOTE: 큐레이션이 상품 목록을 들고있어서, 최대 10개 미만으로 요청받음
    size: z.number().min(1).max(10),
    curationId: z.string().optional(),
    type: CurationTypeSchema.optional(),
  })
  .describe('GetCurationsServiceRequestSchema');
export type GetCurationsServiceRequest = z.infer<typeof GetCurationsServiceRequestSchema>;

// 방문자를 위한 큐레이터 상품 스키마
const VisitorCurationGoodsItemSchema = z
  .object({
    goodsNo: z.string(),
    imageUrl: z.string(),
    isLiked: z.boolean(),
    brandNo: z.number().nullable(),
    brandName: z.string(),
    goodsName: z.string(),
    salesRate: z.number(),
    price: z.number(),
    normalPrice: z.number().nullable(),
    couponPrice: z.number().nullable(),
    couponSalesRate: z.number().nullable(),
    extraDiscountAmount: z.number().nullish(),
    finalPrice: z.number().nullish(),
    finalDiscount: z.number().nullish(),
    isLowestPrice: z.boolean().nullish(),
    isExclusive: z.boolean(),
    hasOptionPrice: z.boolean().nullable(),
    expectedEarnings: z.number().optional(),
    likeCount: z.number(),
    reviewScore: z.string(),
    reviewCount: z.number(),
    existsCoupon: z.boolean().optional(),
    linkUrl: z.string().optional(),
    isSoldOut: z.boolean(),
    ordNo: z.number().optional(),
    largeCategoryNo: z.number().optional().nullable(),
    largeCategoryName: z.string().optional().nullable(),
    middleCategoryNo: z.number().optional().nullable(),
    middleCategoryName: z.string().optional().nullable(),
    smallCategoryNo: z.number().optional().nullable(),
    smallCategoryName: z.string().optional().nullable(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  })
  .describe('VisitorCurationGoodsItemSchema');

const VisitorCurationSnapItemSchema = z
  .object({
    id: z.string(),
    imageUrl: z.string(),
    linkUrl: z.string(),
  })
  .describe('VisitorCurationSnapItemSchema');

export const VisitorCurationItemSchema = z
  .object({
    curationId: z.string(),
    description: z.string().optional().nullable(),
    title: z.string(),
    type: CurationTypeSchema.nullable().optional(),
    ordNo: z.number(),
    goodsItems: z.array(VisitorCurationGoodsItemSchema),
    snapItems: z.array(VisitorCurationSnapItemSchema).optional().default([]),
  })
  .describe('VisitorCurationItemSchema');

export type VisitorCurationItem = z.infer<typeof VisitorCurationItemSchema>;
export type VisitorCurationGoodsItem = z.infer<typeof VisitorCurationGoodsItemSchema>;
export type VisitorCurationSnapItem = z.infer<typeof VisitorCurationSnapItemSchema>;

export const GetCurationsServiceResponseSchema = z.object({
  total: z.number(),
  list: z.array(VisitorCurationItemSchema),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type GetCurationsServiceResponse = z.infer<typeof GetCurationsServiceResponseSchema>;
